<template>
  <MovableDialog v-if="signalsStore.incoming && session.isPlayerOrSpectator" class="signal-request-panel modal"
    :position="position" :isOpen="isOpen" :hasNotif="true" :title="t('modal.signals.waiting')"
    @toggle="isOpen = !isOpen" @position="position = $event">
    <div class="signal-request">
      <div v-if="signalsStore.incoming.items.length" class="signal-items">
        <SignalChip v-for="(item, index) in signalsStore.incoming.items" :key="index" :item="item" />
      </div>

      <template v-if="signalsStore.incoming.kind === 'request'">
        <SignalComposer :tabs="signalsStore.incoming.tabs" />

        <div class="signal-actions">
          <button type="button" class="signal-button send" :disabled="!signalsStore.draft.length"
            @click="signalsStore.respond()">
            <font-awesome-icon :icon="['fas', 'paper-plane']" />
            {{ t("modal.signals.sendAnswer") }}
          </button>
        </div>
      </template>

      <div v-else class="signal-actions">
        <button type="button" class="signal-button yes" @click="signalsStore.acknowledge()">
          <font-awesome-icon :icon="['fas', 'check']" />
          {{ t("modal.signals.gotIt") }}
        </button>
      </div>
    </div>
  </MovableDialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { MovableDialog, SignalChip, SignalComposer } from "@/components";
import { useLocaleStore, useSessionStore, useSignalsStore } from "@/stores";
import type { Position } from "@/types";

const session = useSessionStore();
const signalsStore = useSignalsStore();
const t = useLocaleStore().t;

const isOpen = ref(true);
const position = ref<Position>({ x: 40, y: 90 });
</script>

<style scoped lang="scss">
.signal-request-panel {
  border: 3px solid red;
  animation: signal-pulse 1s ease-in-out infinite alternate;
}

@keyframes signal-pulse {
  from {
    box-shadow: 0 0 8px 2px rgba(255, 0, 0, 0.5);
  }

  to {
    box-shadow: 0 0 20px 6px rgba(255, 0, 0, 0.9);
  }
}

.signal-request {
  display: flex;
  flex-direction: column;
  width: min(32em, 85vw);
}

.signal-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.signal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  justify-content: center;
}

.signal-button {
  display: inline-flex;
  align-items: center;

  &.yes svg {
    color: #4caf50;
  }

  &.send svg {
    color: rgb(31, 101, 255);
  }

  &[disabled] svg {
    color: inherit;
  }
}
</style>
